import { Client } from "../client";

export abstract class BaseEvent {
	protected client: Client;

	constructor(client: Client) {
		this.client = client;
	}
}